import React, { useEffect, useState, useContext } from "react";
import "./Sidebar.css";
import IresponseFireLogo from "../../Assets/Icons/IresponseFireLogo.svg";
import IresponseFireLogoDark from "../../Assets/Icons/IresponseFireLogoDark.svg";
import BscbConverge_Logo from "../../Assets/Icons/bscbConvergeLogo.png";
import BscbConverge_Icon from "../../Assets/Icons/bscbConvergeIcon.png";
import IResponse_Logo from "../../Assets/Icons/IResponse_Logo.svg";
import navLinks from "../../JsonData/navLinksData";
import { LayoutState } from "../../Context/LayoutContext/LayoutContext";
import { useNavigate } from "react-router-dom";
import NavItem from "../NavItem";
import { useKeycloak } from "@react-keycloak/web";
import { appserveraddr } from "../../Services/EndPoints";
import { Modal, Button } from "react-bootstrap";
import { getData } from "../../Services/Services";
import {
  getStoredFormTemplates,
  findPermissionsByUser,
  findRolesByUser,
} from "../../Services/EndPoints";
import Signout from "../Signout/Signout";
import { ThemeContext } from "../..";

const Sidebar = () => {
  const { collapsed, toggle } = LayoutState();
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const [navigableLinks, setNavigableLinks] = useState([]);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    addReportMenu();
  }, []);

  const sanitizeMenus = async (navLinkArr) => {
    try {
      let permissionArr = await getData(findPermissionsByUser);
      
      // Extract all permission IDs that the user has
      let userPermissionIds = permissionArr.map(permission => permission.id);
      
      console.log('User permissions:', userPermissionIds);
      console.log('Original navLinks:', navLinkArr);

      // Process all navigation items
      let navLinkSanitised = navLinkArr.map(navItem => {
        if (!navItem.children || navItem.children.length === 0) {
          return navItem;
        }

        // Filter children based on permissions
        const filteredChildren = navItem.children.filter(childItem => {
          // If no permission requirement, allow the item
          if (!childItem.allowedPermissionIds) {
            return true;
          }
          
          // Check if user has any of the required permissions
          return childItem.allowedPermissionIds.some(requiredPermissionId => 
            userPermissionIds.includes(requiredPermissionId)
          );
        });

        // Recursively filter nested children
        const processNestedChildren = (children) => {
          return children.map(child => {
            if (!child.children || child.children.length === 0) {
              return child;
            }

            const nestedFilteredChildren = child.children.filter(nestedChild => {
              if (!nestedChild.allowedPermissionIds) {
                return true;
              }
              
              return nestedChild.allowedPermissionIds.some(requiredPermissionId => 
                userPermissionIds.includes(requiredPermissionId)
              );
            });

            return {
              ...child,
              children: processNestedChildren(nestedFilteredChildren)
            };
          });
        };

        return {
          ...navItem,
          children: processNestedChildren(filteredChildren)
        };
      });

      // Filter out items based on permissions
      navLinkSanitised = navLinkSanitised.filter(navItem => {
        // For standalone items (no children), check their own permissions
        if (!navItem.children || navItem.children.length === 0) {
          console.log(`Checking standalone item: ${navItem.label || navItem.name}`, {
            allowedPermissionIds: navItem.allowedPermissionIds,
            hasPermission: !navItem.allowedPermissionIds || navItem.allowedPermissionIds.some(requiredPermissionId => 
              userPermissionIds.includes(requiredPermissionId)
            )
          });
          
          // If no permission requirement, HIDE the item (strict mode)
          if (!navItem.allowedPermissionIds || navItem.allowedPermissionIds.length === 0) {
            return false;
          }
          // Check if user has any of the required permissions
          return navItem.allowedPermissionIds.some(requiredPermissionId => 
            userPermissionIds.includes(requiredPermissionId)
          );
        }
        
        console.log(`Checking parent item: ${navItem.label || navItem.name}`, {
          childrenCount: navItem.children.length
        });
        
        // For parent items with children, only keep if there are accessible children after filtering
        return navItem.children.length > 0;
      });

      console.log('Filtered navigation links:', navLinkSanitised);
      setNavigableLinks(navLinkSanitised);
    } catch (error) {
      console.error('Error sanitizing menus:', error);
      // Fallback: show all menus if there's an error
      setNavigableLinks(navLinkArr);
    }
  };

  const addReportMenu = async () => {
    try {
      var data = await getData(getStoredFormTemplates);
      let formStructArr = [];
      
      if (data && Array.isArray(data)) {
        data.forEach(function (dataElems) {
          formStructArr.push({
            to: "../../report-view/" + dataElems.form_name,
            label: dataElems.form_name,
          });
        });
      }
      
      console.log('Form structure array:', formStructArr);
      
      // Apply menu filtering
      await sanitizeMenus(navLinks);
    } catch (error) {
      console.error('Error adding report menu:', error);
      // Fallback: apply filtering to original navLinks
      await sanitizeMenus(navLinks);
    }
  };

  return (
    <div className={`${collapsed ? "sb-collapsed" : "sidebar"}`}>
      <div
        className={` mt-3 sidebar__top ${
          collapsed ? " sidebar__top--collapsed" : null
        }`}
      >
      </div>
      <div className="sidebar__content">
        <div className="menu">
          <ul className={`nav__list ${collapsed && "nav__list--collapsed"}`}>
            {navigableLinks.map((item, index) => (
              <NavItem item={item} index={index} key={index} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;